/* eslint-disable max-len */
import React from 'react';

import { Container } from '@components/Container';
import { Layout } from '@components/Layout';
import { makeMuiStyles, useCommonStyles } from '@styles';
import { createStrings } from '@utils/local';
import { PageMeta } from '@utils/pages';

const strings = createStrings({
  ja: {
    title: 'クッキー（Cookie）ポリシー',
    bannerTitle: 'クッキーポリシー',
    content: `\
<b>
クッキー（Cookie）の利用について
</b>
当社では、サービス向上およびお客様により適したサービスを提供するため、クッキーを利用しています。 


<b>
クッキー（Cookie）とは？
</b> 

クッキー（Cookie）とは、お客様がエフシースタンダードロジックスサイトを閲覧する時、お客様の端末に保管される、アクセス情報を記載されるファイルです。


<b>
クッキー（Cookie）の使用について
</b>

当社では、お客さまが次回にエフシースタンダードロジックスサイトを閲覧する時、お客様のブラウザを認識できます。お客様の利用者ID、パスワード等を毎回入力する手間を省いたり、訪れたページの履歴。


<b>
当社ウェブサイトで使用するクッキー（Cookie）について
</b>

当社ウェブサイトでは、ユーザーの認証情報が含まれているToken クッキー（Cookie）を使用いたします。個人情報及び個人関連情報の取集はできません。
・Backend Token
Djangoがクライアントからのリクエストに初めて応答すると、サーバー側でランダムにトークンが生成され、このトークンがCookieに配置されます。 
・Frontend Token
Djangoがクライアントからのリクエストに初めて応答すると、サーバー側でランダムにトークンが生成され、このトークンがCookieやLocal Storageに配置されます。
  


<b>
クッキー（Cookie）のアクセス許可をコントロールする方法？ 
</b>

クッキー（Cookie）の受信を希望しない場合は、ブラウザーの設定を変更して、クッキー（Cookie）の受信時に通知を表示するか、すべてのクッキー（Cookie）を拒否することができます。 また、すでに保存されているクッキー（Cookie）をユーザー次第で削除することもできます。ブラウザによって操作方法は異なるため、詳しくはお使いのブラウザのヘルプをご確認ください。

  

<b>
ユーザー同意書 
</b>

お客様は、ブラウザの設定を変更することにより、Cookieを受け付けるかどうか選択することができます。ただし、Cookieを無効にした場合は、無効にされたCookieの種類に応じて、弊社サイトの一部の機能をご利用いただけなかったり、想定通りに動作しないこととなります。 
`,
  },
});

const useStyles = makeMuiStyles((theme, common) => ({
  title: {
    ...common.normalText,
    textAlign: 'center',
    fontWeight: 700,
    fontSize: 30,
    lineHeight: '42px',
    marginBottom: '6rem',
  },
  content: {
    ...common.normalText,
    whiteSpace: 'pre-wrap',
    '& b': {
      color: theme.palette.grey['800'],
    },
    color: theme.palette.grey['700'],
  },
}));

export const CookiePolicy: React.FC = () => {
  const classes = {
    ...useCommonStyles(),
    ...useStyles(),
  };

  return (
    <Layout title={strings.title} breadcrumbs={['/utilities/Dashboard', '/about/CookiePolicy']}>
      <Container>
        <div className={classes.title}>{strings.title}</div>
        <div className={classes.content} dangerouslySetInnerHTML={{ __html: strings.content }} />
      </Container>
    </Layout>
  );
};

export const meta: PageMeta = {
  title: strings.bannerTitle,
};
